export abstract class SessionManager {
  abstract hasSession(): boolean;
  abstract getSession(): string | null;
  abstract setSession(value: string, expirationDays?: number): void;
  abstract clearSession(): void;
  abstract refreshSession(expirationDays?: number): void;
}
